var exports = {
  "tB": "ContextMenu.module__backdrop___MEZQVX",
  "D8": "ContextMenu.module__contextMenuPositioner___MEZQVX",
  "He": "ContextMenu.module__contextMenu___MEZQVX",
  "KY": "ContextMenu.module__menuScroller___MEZQVX",
  "NC": "ContextMenu.module__menuScrollerContent___MEZQVX",
  "AS": "ContextMenu.module__item___MEZQVX",
  "r9": "ContextMenu.module__disabled___MEZQVX",
  "OR": "ContextMenu.module__danger___MEZQVX",
  "Fx": "ContextMenu.module__itemIcon___MEZQVX",
  "IR": "ContextMenu.module__itemLabel___MEZQVX",
  "Ah": "ContextMenu.module__itemWithShortcut___MEZQVX",
  "g$": "ContextMenu.module__itemShortcut___MEZQVX",
  "ED": "ContextMenu.module__itemShortcutHidden___MEZQVX",
  "dP": "ContextMenu.module__itemLabelContainer___MEZQVX",
  "b": "ContextMenu.module__itemLabelText___MEZQVX",
  "Lo": "ContextMenu.module__itemHint___MEZQVX",
  "fV": "ContextMenu.module__submenuCaret___MEZQVX",
  "me": "ContextMenu.module__separator___MEZQVX",
  "Os": "ContextMenu.module__group___MEZQVX",
  "_0": "ContextMenu.module__selectableSection___MEZQVX",
  "dl": "ContextMenu.module__checkboxItem___MEZQVX",
  "fb": "ContextMenu.module__checkboxIndicator___MEZQVX",
  "kv": "ContextMenu.module__checkbox___MEZQVX",
  "xY": "ContextMenu.module__checkboxChecked___MEZQVX",
  "AM": "ContextMenu.module__groupLabel___MEZQVX",
  "HG": "ContextMenu.module__submenuPopover___MEZQVX",
  "a": "ContextMenu.module__submenuScroller___MEZQVX",
  "pT": "ContextMenu.module__quickReactionsGroup___MEZQVX",
  "gV": "ContextMenu.module__quickReactionItem___MEZQVX",
  "z5": "ContextMenu.module__quickReactionShortcut___MEZQVX",
  "dd": "ContextMenu.module__quickReactionTooltipContent___MEZQVX",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___MEZQVX",
  "hH": "ContextMenu.module__emojiSubmenuIcon___MEZQVX",
  "XN": "ContextMenu.module__emojiSubmenuImg___MEZQVX",
};

module.exports = exports;
